import { debug } from '../../utils/DebugUtil';

/**
 * Infer if notifications will work in the current browser state
 */
export const canShowBrowserNotifications = () => {
  const supportsNotifications = ('Notification' in window);
  if (!supportsNotifications) {
    debug('Browser does not support notifications - cannot show browser notifications');
    return false;
  }
  if (Notification.permission !== 'granted') {
    debug(`Browser notification permission is ${Notification.permission} - cannot show browser notifications`);
    return false;
  }
  return true;
};